<h1 data-automation-name="login"> Venway Login </h1>
@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<p class="lead">
  Enter your LDAP credentials below.
</p>
<form name="loginForm"  style="max-width: 400px;" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label>Username (without &#64;enernoc.com)</label>
    <input type="text" placeholder="Username" formControlName="username" class="form-control input-box">
  </div>
  <div class="form-group">
    <input type="password" placeholder="Password" formControlName="password" class="form-control input-box">
  </div>
  <div class="checkbox">
    <label><input type="checkbox"> Remember me </label>
  </div>
  <button id="loginButton" type="submit" class="btn btn-primary" [disabled]="form.invalid"> Login </button>
  <br>
</form>
